const enc = src => src.replace(/%40/g, '');

export default (a, b, c) => `${enc(a)}, ${enc(b)} 2x, ${enc(c)} 3x`;
